var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconUsersList = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#83868D",
  fillRule: "evenodd",
  d: "M6.987 2.656a2 2 0 0 1 2.26-1.299l8.502 1.62a2 2 0 0 1 1.506 2.647l-3.618 9.95-.026.052c-.53 1.06-1.099 1.862-1.856 2.379-.782.533-1.635.674-2.539.674-1.28 0-2.13-.815-2.627-1.582-.497-.769-.76-1.657-.859-2.254a1 1 0 1 1 1.973-.329c.067.403.254 1.015.566 1.497s.627.668.947.668c.697 0 1.094-.11 1.412-.327.337-.23.71-.664 1.169-1.57l3.377-9.289a.5.5 0 0 0-.376-.662L9.296 3.402a.5.5 0 0 0-.566.325L6.16 11.01a1 1 0 0 1-1.887-.665z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#83868D",
  d: "m1.713 11.61 7.263 2.102c0 1.2 1.128 3.92 1.795 4.92-2-.334-5.88-1.448-7.88-2.248-1.576-.63-2.225-2.581-2.267-4.033-.016-.566.544-.899 1.089-.741"
})));
export default SvgIconUsersList;